export default __webpack_public_path__ + "static/broadcastImg2-b2c35ff5aaf0b72da8c86d2b80c408e7.png";